import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import VisitorConsentPage from "../../features/VisitorConsent/visitor-consent.page";

/** Public magic-link flow only — no Keycloak, no admin consent providers. */
const PublicVisitorConsentRouter: React.FC = () => (
  <Router>
    <Switch>
      <Route path="/visit/consent/:token" component={VisitorConsentPage} />
    </Switch>
  </Router>
);

export default PublicVisitorConsentRouter;
